const LOGIN_BUTTONS_SELECTORS = {
    LOGIN_BUTTON_ID: '#cgp-login-btn',
    REGISTER_BUTTON_ID: '#login_button_register'
};

export {LOGIN_BUTTONS_SELECTORS};